<template>
  <b-modal
    title="EDITAR PERGUNTA"
    no-close-on-backdrop
    hide-footer
    id="modify_question"
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <b-form @submit.prevent="evOnSubmit">
        <b-row>
          <b-col>
            <h6 class="mb-0 upper-text">Modelo: <label-required-field /></h6>
            <b-input v-model="type_name" readonly />
            <span class="text-muted">{{ type_description }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-checkbox :disabled="!editable" v-model="mandatory">
              Obrigatória
            </b-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 class="mb-0 upper-text">Enunciado: <label-required-field /></h6>
            <b-textarea
              :disabled="!editable"
              rows="3"
              ref="autofocus"
              placeholder="Digite o Enunciado"
              v-model="statement"
            />
          </b-col>
        </b-row>
        <b-form
          v-on:submit.stop.prevent="evOnAddAlternativeSubmit"
          v-if="type_value != 'OPEN'"
        >
          <h6 class="mb-0 upper-text">ADICIONAR ALTERNATIVAS:</h6>
          <b-row align-v="center">
            <b-col>
              <b-input
                placeholder="Digite a alternativa"
                ref="new_alternative"
                v-model="new_alternative"
              />
            </b-col>
            <b-col cols="auto">
              <v-btn type="submit" class="btn-add-down">
                <i class="fas fa-arrow-down mr-2 text-twenty"></i> ADICIONAR
              </v-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div
                v-if="
                  current_alternatives.length > 0 || new_alternatives.length > 0
                "
              >
                <div
                  class="mb-2"
                  v-for="(item, index) in current_alternatives"
                  :key="`current_${index}`"
                >
                  <b-input-group>
                    <b-input v-model="current_alternatives[index].label" />
                    <template #append>
                      <v-btn
                        class="btn-delete ml-1"
                        @click="removeCurrentAlternative(index)"
                      >
                        <i class="fas fa-trash text-twenty" />
                      </v-btn>
                    </template>
                  </b-input-group>
                </div>
                <div
                  class="mb-2"
                  v-for="(item, index) in new_alternatives"
                  :key="`new_${index}`"
                >
                  <b-input-group>
                    <b-input v-model="new_alternatives[index]" />
                    <template #append>
                      <b-button
                        variant="outline"
                        @click="removeNewAlternative(index)"
                      >
                        <i class="fas fa-trash text-twenty" />
                      </b-button>
                    </template>
                  </b-input-group>
                </div>
              </div>
              <div v-else class="text-center p-5 v-clean">
                <h6 class="text-center upper-text worksansr mb-0">
                  Nenhuma alternativa adicionada
                </h6>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <warning-required-fields />
        <errors-messages :errors="errors" />
        <b-row align-h="between">
          <b-col cols="auto">
            <v-btn
              class="btn-cancel m-1"
              @click="$bvModal.hide('modify_question')"
            >
              CANCELAR
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <v-btn v-if="editable" type="submit" class="btn-save m-1">
              <i class="fas fa-save mr-2 text-twenty"></i>
              SALVAR
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "ModifyQuestion",
  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },
  props: {
    form_id: [String, Number],
    category_id: [String, Number],
    question_id: [String, Number],
    editable: Boolean,
  },
  data() {
    return {
      errors: [],
      loading: false,
      type_value: "",
      type_name: "",
      type_description: "",
      statement: "",
      mandatory: false,

      current_alternatives: [],
      new_alternatives: [],
      new_alternative: "",
    };
  },
  methods: {
    async retrieve() {
      await this.getQuestion();
    },
    async getQuestion() {
      try {
        this.loading = true;

        const params = {
          form_id: this.form_id,
          category_id: this.category_id,
          question_id: this.question_id,
        };
        const response = await api.get(
          "/rest-home/semiology/form/category/question",
          { params }
        );
        const { error, errors, question } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.type_value = question.type_value;
          this.type_name = question.type_name;
          this.type_description = question.type_description;
          this.statement = question.statement;
          this.mandatory = question.mandatory == 1;
          this.current_alternatives = question.alternatives;
          this.new_alternatives = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;
    },
    async evOnShown() {
      await this.retrieve();
      this.$refs.autofocus.focus();
    },
    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (
          this.type_value != "OPEN" &&
          this.current_alternatives.length + this.new_alternatives.length == 0
        )
          this.errors.push("Informe as alternativas");

        if (this.errors.length > 0) {
          this.loading = false;
          return;
        }

        let data = {
          form_id: this.form_id,
          category_id: this.category_id,
          question_id: this.question_id,
          statement: this.statement,
          mandatory: this.mandatory,
          current_alternatives: this.current_alternatives,
          new_alternatives: this.new_alternatives,
        };
        let response = await api.patch(
          "/rest-home/semiology/form/category/question",
          data
        );
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$emit("updated");
          toast(message, "success");
          this.$bvModal.hide("modify_question");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async evOnAddAlternativeSubmit() {
      if (!this.new_alternative) {
        this.$refs.new_alternative.focus();
        this.errors = ["Informe a alternativa"];
        return;
      }
      if (
        this.type_value.value == "DICHOTOMOUS" &&
        this.new_alternatives.length >= 2
      ) {
        this.$refs.new_alternative.focus();
        this.errors = ["Somente duas alternativas são possíveis em dicotômica"];
        return;
      }
      this.errors = [];
      this.new_alternatives.push(this.new_alternative);
      this.new_alternative = "";
      this.$refs.new_alternative.focus();
    },

    async removeCurrentAlternative(index) {
      this.current_alternatives.splice(index, 1);
    },

    async removeNewAlternative(index) {
      this.new_alternatives.splice(index, 1);
    },
  },
};
</script>

<style></style>
